/* eslint-disable max-len */
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('userManagement.Rsrc');
export default {
  get expiredTokenSuccessHeaderText() {
    return Config.get('ResourceUsers', 'expiredTokenSuccessHeaderText', t('expiredTokenSuccessHeaderText'));
  },
  get expiredTokenSuccessSubheaderText() {
    return Config.get('ResourceUsers', 'expiredTokenSuccessSubheaderText', t('expiredTokenSuccessSubheaderText'));
  },
  get expiredTokenFieldValidators() {
    return Config.get('ResourceUsers', 'expiredTokenFieldValidators', null);
  },
  get expiredTokenSubmitText() {
    return Config.get('ResourceUsers', 'expiredTokenSubmitText', t('expiredTokenSubmitText'));
  },
  get expiredTokenPaneVariant() {
    return Config.get('ResourceUsers', 'expiredTokenPaneVariant', 'expiredActivationToken');
  },
  get expiredTokenHeaderText() {
    return Config.get('ResourceUsers', 'expiredTokenHeaderText', t('expiredTokenHeaderText'));
  },
  get expiredTokenHeaderVariant() {
    return Config.get('ResourceUsers', 'expiredTokenHeaderVariant', 'sectionTitle');
  },
  get expiredTokenInputTitleVariant() {
    return Config.get('ResourceUsers', 'expiredTokenInputTitleVariant', 'inputTitle');
  },
  get expiredTokenInputVariant() {
    return Config.get('ResourceUsers', 'expiredTokenInputVariant', 'formInput');
  },
  get expiredTokenInputClassName() {
    return Config.get('ResourceUsers', 'expiredTokenInputClassName', '');
  },
  get expiredTokenUsernameText() {
    return Config.get('ResourceUsers', 'expiredTokenUsernameText', t('expiredTokenUsernameText'));
  },
  get expiredTokenUsernameHint() {
    return Config.get('ResourceUsers', 'expiredTokenUsernameHint', t('expiredTokenUsernameHint'));
  },
  get expiredTokenSubheadaerVariant() {
    return Config.get('ResourceUsers', 'expiredTokenSubheadaerVariant', 'body');
  },
  get expiredTokenSubheaderText() {
    return Config.get('ResourceUsers', 'expiredTokenSubheaderText', t('expiredTokenSubheaderText'));
  },
  get expiredTokenSubheaderClassName() {
    return Config.get('ResourceUsers', 'expiredTokenSubheaderClassName', null);
  },
  get activateAccountFieldValidators() {
    return Config.get('ResourceUsers', 'activateAccountFieldValidators', null);
  },
  get activateAccountPreSubmitComponents() {
    return Config.get('ResourceUsers', 'activateAccountPreSubmitComponents', null);
  },
  get activateAccountValidator() {
    return Config.get('ResourceUsers', 'activateAccountValidator', () => true);
  },
  get activateAccountCustomOnSubmit() {
    return Config.get('ResourceUsers', 'activateAccountCustomOnSubmit', () => null);
  },
  get activateAccountSupportsLogin() {
    return Config.get('ResourceUsers', 'activateAccountSupportsLogin', true);
  },
  get usernameLabel() {
    return Config.get('ResourceUsers', 'userSelectorUsernameLabel', t('userSelectorUsernameLabel'));
  },
  get usernameHint() {
    return Config.get('ResourceUsers', 'userSelectorUsernameHint', t('userSelectorUsernameHint'));
  },
  get usernameInstructions() {
    return Config.get('ResourceUsers', 'userSelectorUsernameInstructions', t('userSelectorUsernameInstructions'));
  },
  get usernameColumnLabel() {
    return Config.get('ResourceUsers', 'usernameColumnLabel', t('usernameColumnLabel'));
  },
  get emailColumnLabel() {
    return Config.get('ResourceUsers', 'usersTableEmailLabel', t('usersTableEmailLabel'));
  },
  get addUserTitle() {
    return Config.get('ResourceUsers', 'addUserTitle', t('addUserTitle'));
  },
  get editUserTitle() {
    return Config.get('ResourceUsers', 'editUserTitle', t('editUserTitle'));
  },
  get addUserOkay() {
    return Config.get('ResourceUsers', 'addUserOkay', t('addUserOkay'));
  },
  get editUserOkay() {
    return Config.get('ResourceUsers', 'editUserUpdate', t('editUserUpdate'));
  },
  get userSearchField() {
    return Config.get('ResourceUsers', 'userSearchField');
  },
  get allowCreateUser() {
    return Config.get('ResourceUsers', 'allowCreateUser', true);
  },
  get allowInviteUser() {
    return Config.get('ResourceUsers', 'allowInviteUser', true);
  },
  get inviteEmailLabel() {
    return Config.get('ResourceUsers', 'inviteEmailLabel', t('inviteEmailLabel'));
  },
  get inviteEmailHint() {
    return Config.get('ResourceUsers', 'inviteEmailHint', t('inviteEmailHint'));
  },
  get createEmailLabel() {
    return Config.get('ResourceUsers', 'createEmailLabel', t('createEmailLabel'));
  },
  get createEmailHint() {
    return Config.get('ResourceUsers', 'createEmailHint', t('createEmailHint'));
  },
  get createUsernameLabel() {
    return Config.get('ResourceUsers', 'createUsernameLabel', t('createUsernameLabel'));
  },
  get createUsernameHint() {
    return Config.get('ResourceUsers', 'createUsernameHint', t('createUsernameHint'));
  },
  get activateEmailLabel() {
    return Config.get('ResourceUsers', 'activateEmailLabel', t('activateEmailLabel'));
  },
  get createNameLabel() {
    return Config.get('ResourceUsers', 'createNameLabel', t('createNameLabel'));
  },
  get createNameHint() {
    return Config.get('ResourceUsers', 'createNameHint', t('createNameHint'));
  },
  get createPhoneLabel() {
    return Config.get('ResourceUsers', 'createPhoneLabel', t('createPhoneLabel'));
  },
  get createPhoneHint() {
    return Config.get('ResourceUsers', 'createPhoneHint', t('createPhoneHint'));
  },
  get createPasswordLabel() {
    return Config.get('ResourceUsers', 'createPasswordLabel', t('createPasswordLabel'));
  },
  get createPasswordHint() {
    return Config.get('ResourceUsers', 'createPasswordHint', t('createPasswordHint'));
  },
  get createConfirmPasswordLabel() {
    return Config.get('ResourceUsers', 'createConfirmPasswordLabel', t('createConfirmPasswordLabel'));
  },
  get createConfirmPasswordHint() {
    return Config.get('ResourceUsers', 'createConfirmPasswordHint', t('createConfirmPasswordHint'));
  },
  get userSelectorEmailLabel() {
    return Config.get('ResourceUsers', 'userSelectorEmailLabel', t('userSelectorEmailLabel'));
  },
  editUserRolesTitle(user) {
    const prefix = Config.get('ResourceUsers', 'editUserRolesTitle', t('editUserRolesTitle'));
    if (user) {
      const {
        name,
        username,
        type,
        userType,
        email
      } = user;
      if (type === 'apiAccess') {
        return t('apiAccess', {
          prefix,
          name
        });
      }
      if (userType === 'oidc' || userType === 'pendingOidc') {
        // ToDO: would be nice to get the oidc name and put something like 'through Google'
        return t('openId', {
          prefix,
          name: name || email
        });
      }
      if (username && name && name !== username) {
        return `${prefix}${name} (${username})`;
      }
      return `${prefix}${name || username || email}`;
    }
    return t;
  },
  get editUserRolesOkay() {
    return Config.get('ResourceUsers', 'editUserRolesUpdate', t('editUserRolesUpdate'));
  }
};